<template>
    <div>
        <el-row>
            <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
                <el-tooltip class="item" effect="dark" content="返回上一级页面" placement="bottom-start" :disabled="showTooltip">
                    <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
                </el-tooltip>
            </el-col>
            <el-col :span="12">
                <h3><span v-show="!create">修改编码对照信息</span><span v-show="create">新增编码对照信息</span></h3>
            </el-col>
        </el-row>
        <div style="max-width: 800px">
            <el-form ref="form" :model="form" :rules="formRules" label-width="180px" v-loading="showLoading">
                <el-row>
                        <el-col :span="24">
                            <el-form-item prop="agencyName" label="开票单位名称">
                                <el-input ref="agencyName" v-model="form.agencyName" maxlength="120" :disabled="!create"
                                          @focus="() => {
                                            showDiyTree(treeData, form.agencyCode, {title:'开票单位', placeholder: '请输入开票单位名称', treeCallBack: (nodes) => {
                                                let agencyName = ''
                                                if (nodes.length == 0) {
                                                    this.form.agencyCode = ''
                                                } else {
                                                    this.form.agencyCode = nodes[0].id;
                                                    agencyName = nodes[0].label;
                                                    this.form.supProCode = nodes[0].pid;
                                                    this.form.supProName = nodes[0].plabel;
                                                }
                                                this.$set(this.form, 'agencyName', agencyName)
                                                this.$refs.agencyName.blur()
                                            }})
                                          }"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="系统字段" prop="fieldCode">
                            <el-input ref="ipt02" v-model="form.fieldCode" placeholder="请输入" maxlength="50" show-word-limit :disabled="!create"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="有效标志" prop="isValid">
                            <el-select v-model="form.isValid">
                                <el-option label="是" value="Y"></el-option>
                                <el-option label="否" value="N"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="业务系统值" prop="oldValue">
                            <el-input ref="ipt03" v-model="form.oldValue" placeholder="请输入" maxlength="100" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="票据系统值" prop="newValue">
                            <el-input ref="ipt04" v-model="form.newValue" placeholder="请输入" maxlength="100" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="备注" prop="remark">
                            <el-input ref="ipt05" type="textarea" :rows="3" v-model="form.remark" placeholder="请输入" maxlength="200" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                
                <el-form-item>
                    <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
        <tree ref="myTree" @treeCallBack="treeCallBack($event)"></tree>
    </div>
</template>

<script>
   // import _ from "lodash"
    import tree from "./Tree"

    let _kits, _form, fn
    export default {
        components: {
            tree
        },
        props: ["entity"],
        data() {
            var checkFieldCode = (rule, value, callback) => {
                const reg = /^[0-9A-Za-z]*$/;
                if (!reg.test(value)) {
                    callback(new Error("系统字段只能是数字和字母组成"));
                } else {
                    callback();
                }
            };
            let create = !this.entity.agencyCode
            let form
            if (create) {
                form = {
                    agencyCode: "",
                    fieldCode: "",
                    oldValue: "",
                    newValue: "",
                    reamrk: "",
                    isValid: "Y"

                }
            } else {
                form = Object.assign({}, this.entity)
                console.log(this.entity)
            }
            let data = {
                showLoading: true,
                showTooltip: false,
                showBtnLoading: false,
                create,
                form,
                formRules: {
                    agencyName: [{
                            required: true,
                            message: "请输入开票单位名称",
                            trigger: "blur"
                        },
                        {
                            max: 30,
                            message: "最多30个字符",
                            trigger: "blur"
                        }
                    ],
                    fieldCode: [{
                            required: true,
                            message: "请输入系统字段",
                            trigger: "blur"
                        }, {
                            validator: checkFieldCode,
                            trigger: "blur"
                        },{
                            max: 50,
                            message: "最多50个字符",
                            trigger: "blur"
                        }
                    ],
                    oldValue: [{
                            required: true,
                            message: "请输入业务系统值",
                            trigger: "blur"
                        },{
                            max: 100,
                            message: "最多100个字符",
                            trigger: "blur"
                        }
                    ],
                    newValue: [{
                            required: true,
                            message: "请输入票据系统值",
                            trigger: "blur"
                        },{
                            max: 100,
                            message: "最多100个字符",
                            trigger: "blur"
                        }
                    ],isValid: [{
                        required: true,
                        message: "请选择有效标志",
                        trigger: "blur"
                    }]
                }
            }
            console.log("data is ", data)
            return data
        },
        methods: {
            onBack() {
                this.$emit("back")
            },
            onSave() {
                _form.submit()
            },
            showDiyTree(arr, id, option) {
                fn = option.treeCallBack
                this.$refs.myTree.showTree(arr, id, option)
            },

            treeCallBack(nodes) {
                if (fn != undefined) {
                    fn(nodes)
                }
            },
            initTreeData(fn_call, fn_filter) {
                _kits.api.call(
                    "AGENCYTREE",
                    {},
                    result => {
                        if (result.returnCode == "0000") {
                            fn_call(_kits.arr2TreeData(result.data, fn_filter))
                        } else {
                            this.$message.error(result.returnMsg)
                        }
                    }
                )
            }
        },
        created() {
            _kits = this.$kits();
            this.initTreeData(data => {
                this.treeData = data  
            }, a => {
                //a.disabled =    a.type =='1'     // 添加属性
                //return false
            })
        },
        mounted() {
            _form = _kits.control.getStandardForm({
                name: "form",
                api: this.create ? "ADDSYSCOLLATIONDETAILS" : "UPDATESYSCOLLATIONDETAILS"
            })
            //*
            setTimeout(() => {
                _kits.page.foucus("ipt01")
                this.showLoading = false
                this.showTooltip = true
            }, 300)
            //*/
        }
    }
</script>
